import React from 'react';
import { BaseIcon } from './base-icon';
import { IconList } from './icon-list';

type PlaygroundIconProps = { of: IconList } & React.HTMLAttributes<HTMLSpanElement>;

const iconSetPrefix = 'playcon';

export function Icon({ of: iconName, ...rest }: PlaygroundIconProps) {
	return <BaseIcon of={`${iconSetPrefix}-${iconName}`} {...rest} />;
}
